export const enum ADMIN_INTENT_TO_RE_ENROLL_OPTIONS {
  DISABLED = 'Disabled',
  UNLOCK_ENROLLMENT_PACKET = 'Unlock Enrollment Packet',
}
